module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image16.ed75f04f.jpg";